<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="`${isChange ? '修改' : '添加'}招聘会`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="title" label="主题">
        <el-input
          clearable
          v-model="form.data.title"
          maxlength="15"
          placeholder="请输入最多15字"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="date">
        <el-date-picker
          v-model="form.data.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "WealEdit",
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      info: null,
      form: {
        loading: false,
        data: {
          title: "",
          date: [],
        },
        rules: {
          title: [{ required: true, message: "必填项", trigger: "change" }],
          date: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.isChange = false;
      this.info = null;
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      this.isChange = true;
      this.form.data = {
        title: row.title,
        date: [row.start_day, row.end_day],
      };
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            ...this.form.data,
          };
          let [start_day = "", end_day = ""] = params.date;
          params.start_day = start_day;
          params.end_day = end_day;
          delete params.date;
          let url = this.isChange ? "/admin/fair/edit" : "/admin/fair/add";
          if (this.isChange) {
            params.id = this.info.id;
          }
          this.$http
            .post(url, params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
